<template>
  <section id="contact" class="contact">

    <div class="container">

      <div class="contact-header">

        <h2>

          {{ contactLocale.titleFirst }}

          <span class="gradient-text">
            {{ contactLocale.titleSecond }}
          </span>

        </h2>

        <p>
          {{ contactLocale.description }}
        </p>

      </div>

      <div class="contact-grid">

        <div class="contact-info">

          <div class="card">

            <h3 class="gradient-text">
              {{ contactLocale.emailTitle }}
            </h3>

            <p>
              {{ contactLocale.contactInfo.email }}
            </p>

          </div>

          <div class="card">

            <h3 class="gradient-text">
              {{ contactLocale.locationTitle }}
            </h3>

            <p>
              {{ contactLocale.contactInfo.location }}
            </p>

          </div>

          <div class="social-icons">

            <h3 class="gradient-text">
              {{ contactLocale.socialTitle }}
            </h3>

            <p>
              {{ contactLocale.socialDescription }}
            </p>

            <div class="social-links">

              <a v-for="social in socialLinks" :key="social.nome" :href="social.link" target="_blank"
                rel="noopener noreferrer">

                <img :src="social.icon" :alt="social.nome" class="social-icon" />

              </a>

            </div>

          </div>

        </div>

        <!--
        <div class="form-card">

          <form v-if="!success" ref="formRef" @submit.prevent="sendEmail">

            <div class="grid">

              <input v-model="form.name" type="text" name="name" required
                :placeholder="contactLocale.namePlaceholder" />

              <input v-model="form.email" type="email" name="email" required
                :placeholder="contactLocale.emailPlaceholder" />

            </div>

            <select v-model="form.subject" name="subject" required>

              <option value="">
                {{ contactLocale.selectSubject }}
              </option>

              <option v-for="item in contactLocale.subjects" :key="item" :value="item">
                {{ item }}
              </option>

            </select>

            <select v-model="form.budget" name="budget" required>

              <option value="">
                {{ contactLocale.selectBudget }}
              </option>

              <option v-for="item in contactLocale.budgets" :key="item" :value="item">
                {{ item }}
              </option>

            </select>

            <textarea v-model="form.message" name="message" rows="5" required
              :placeholder="contactLocale.messagePlaceholder"></textarea>

            <button type="submit">
              {{ contactLocale.send }}
            </button>

            <Transition name="fade-slide">

              <ReCaptcha v-if="showCaptcha" ref="captchaRef" sitekey="6LcI-WQsAAAAAOEzVJby3HCnRWkYpY_-BwAJROXQ"
                theme="dark" class="recaptcha" @verify="onCaptchaVerified" />


            </Transition>

          </form>

          <div v-else class="success">

            <h3>
              {{ contactLocale.messageSentTitle }}
            </h3>

            <p>
              {{ contactLocale.messageSentDescription }}
            </p>

          </div>

        </div>
      -->

      </div>
    </div>

  </section>
</template>

<script setup>
import { ref, computed } from "vue"
import { useI18n } from "vue-i18n"

import emailjs from "@emailjs/browser"
import ReCaptcha from "vue3-recaptcha2"

import { contact, socialLinks } from "@/data/contact"

const { locale } = useI18n()

const contactLocale = computed(() => {

  if (locale.value === "en") {
    return contact.en
  }

  return contact.pt

})

const { t, tm } = useI18n()

const formRef = ref(null)

const captchaToken = ref(null)

const success = ref(false)

const form = ref({
  name: "",
  email: "",
  subject: "",
  budget: "",
  message: ""
})


const showCaptcha = computed(() => {
  return (
    form.value.name.trim() &&
    form.value.email.trim() &&
    form.value.subject.trim() &&
    form.value.budget.trim() &&
    form.value.message.trim()
  )
})

const captchaRef = ref(null)

const onCaptchaVerified = (token) => {
  captchaToken.value = token
}

const sendEmail = async () => {

  if (!captchaToken.value) {
    alert(t("contact.robotConfirm"))
    return
  }


  try {

    const response = await fetch("https://bp-website-six.vercel.app/api/verify-captcha", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        token: captchaToken.value
      })
    })

    const data = await response.json()

    console.log("captcha response:", data)

    if (!data.success) {
      alert("Captcha inválido")
      return
    }

    await emailjs.sendForm(
      "black_paladins_gmail",
      "contact_us_template",
      formRef.value,
      "dHgVg-7Kh_iUX8y8B"
    )

    success.value = true

    form.value = {
      name: "",
      email: "",
      subject: "",
      budget: "",
      message: ""
    }

    captchaToken.value = null

    setTimeout(() => {
      success.value = false
    }, 3000)

  }
  catch (error) {
    console.log(error)
    alert("Erro ao enviar formulário")
  }
}
</script>

<style scoped>
.contact {
  padding: 50px 20px;
  background: var(--bg-secundario);
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
}

.contact-header h2 {
  font-family: 'Orbitron', sans-serif;
  font-size: clamp(24px, 4vw, 48px);
}

.contact-header p {
  color: var(--cor-texto-suave);
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto 20px;
}

.contact-grid {
  display: flex;
  gap: 60px;
  align-items: stretch;
  justify-content: space-around;
}

.contact-info {
  max-width: 420px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.card {
  max-width: 420px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid var(--card-base);
  background: var(--bg-destaque);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card h3 {
  font-size: 18px;
}

.card p {
  font-size: 15px;
  color: var(--cor-texto-secundario);
}

.form-card {
  max-width: 420px;
  flex: 1;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid var(--card-base);
  background: var(--bg-destaque);
}

.grid {
  display: flex;
  gap: 20px;
}

.grid input {
  flex: 1;
}

input,
textarea,
select {
  width: 100%;
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 12px;
  border: 1px solid var(--card-base);
  background: var(--bg-secundario);
  color: var(--cor-texto-principal);
  letter-spacing: 1px;
}

button {
  width: 100%;
  padding: 18px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  background: var(--card-destaque);
  color: var(--cor-texto-principal);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  transition: 0.3s;
}

button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px var(--card-sombra);
}

.success {
  text-align: center;
  padding: 20px;
}

.social-icons {
  max-width: 420px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid var(--card-base);
  background: var(--bg-destaque);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.social-icons h3 {
  font-size: 18px;
}

.social-icons p {
  margin-bottom: 10px;
  color: var(--cor-texto-secundario);
  font-size: 15px;
}

.social-links {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  transition: 0.3s;
}

.social-links a:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px var(--card-sombra);
}

.social-links img {
  width: 45px;
  height: 45px;
  object-fit: contain;
  border-radius: 12px;
}

.recaptcha{
  margin: 20px;
}

@media (max-width: 800px) {

  .contact {
    padding: 30px 20px;
  }

  .contact-header p {
    font-size: 12px;
    max-width: 400px;
  }

  .contact-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .contact-info {
    max-width: 400px;
    gap: 10px;
  }

  .card {
    max-width: 400px;
    padding: 10px;
    border-radius: 16px;
    gap: 2px;
  }

  .card h3 {
    font-size: 14px;
  }

  .card p {
    font-size: 14px;
  }

  .form-card {
    max-width: 400px;
    padding: 10px;
    border-radius: 16px;
  }

  .grid {
    flex-direction: column;
    gap: 0;
  }

  input,
  textarea,
  select {
    width: 100%;
    padding: 12px;
    margin-bottom: 10px;
    border-radius: 10px;
    font-size: 10px;
  }

  button {
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    font-size: 10px;
  }

  .success {
    padding: 10px;
  }

  .social-icons {
    max-width: 400px;
    padding: 10px;
    border-radius: 16px;
    gap: 2px;
  }

  .social-icons h3 {
    font-size: 14px;
  }

  .social-icons p {
    font-size: 13px;
  }

  .social-links img {
    width: 35px;
    height: 35px;
    border-radius: 10px;
  }

}
</style>